import Vue from "vue";
const vm = new Vue();

export const fieldExport = {
    "INVOICE": [
        // ...( ['shippop','superadmin'].includes(vm.$USER_LOGIN.get().details.role) ) 
        // ? [
            { key: "index", field:"", label: "ลำดับ", sortable: true },
            { key: "sa_code", field: "sa_code", label: "รหัสตัวแทน", sortable: true },
            { key: "shop_code", field: "shop_code", label: "รหัสสาขา", sortable: true },
            { key: "sale_name", field: "sale_name", label: "เซลล์ผู้ดูแล", sortable: true },
            { key: "created_at", field: "created_at", label: "วันที่ออกใบแจ้งหนี้", sortable: true },
            { key: "paid_at", field: "paid_at", label: "วันที่ออกใบเสร็จ", sortable: true },
            { key: "invoice_no", field: "invoice_no", label: "เลขที่ใบแจ้งหนี้", sortable: true },
            { key: "receipt_no", field: "receipt_no", label: "เลขที่ใบเสร็จ", sortable: true },
            { key: "shop_name", field: "shop_name", label: "ชื่อ", sortable: true },
            { key: "order_total", field: "order_total", label: "จำนวน", sortable: true ,
                dataFormat: value => {
                    return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
                } 
            },
            { key: "total_courier_cost", field: "total_courier_cost", label: "ค่าขนส่ง", sortable: true , 
                dataFormat: value => {
                    return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
                }
            },
            { key: "total_additional_fuel_charge", field: "total_additional_fuel_charge", label: "ค่าขนส่ง (Additional Fuel Charge)", sortable: true , 
                dataFormat: value => {
                    return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
                }
            },
            { key: "total_service", field: "total_service", label: "ค่าบริการ (Inc Vat)", sortable: true ,
                dataFormat: value => {
                    return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
                }
            },
            { key: "vat_price", field: "vat_price", label: "Vat", sortable: true ,
                dataFormat: value => {
                    return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
                }    
            },
            { key: "total_service_exclude_vat", field: "total_service_exclude_vat", label: "ค่าบริการ", sortable: true ,
                dataFormat: value => {
                    return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
                }    
            },
            { key: "total", field: "total", label: "คิดเป็นเงิน", sortable: true ,
                dataFormat: value => {
                    return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
                }    
            },
            { key: "total_courier_cost_wht", field: "total_courier_cost_wht", label: "ค่าขนส่ง (หัก 1%)", sortable: true ,
                dataFormat: value => {
                    return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
                }    
            },
            { key: "total_service_exclude_vat_wht", field: "total_service_exclude_vat_wht", label: "ค่าบริการ (หัก 3%)", sortable: true,
                dataFormat: value => {
                    return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
                } 
            },
            { key: "total_net_price", field: "total_net_price", label: "เงินที่จะได้รับ (แบบหักภาษี ณ ที่จ่าย)", sortable: true ,
                dataFormat: value => {
                    return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
                }
            },
            { key: "receipt_amount", field: "receipt_amount", label: "เงินที่เก็บได้", sortable: true , 
                dataFormat: value => {
                    return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
                }    
            },
            { key: "status", field: "status", label: "สถานะ", sortable: true },
            { key: "manage", field:"", label: "จัดการใบแจ้งหนี้", sortable: true }
        // ]
        // : [
        //     { key: "index", field: "index", label: "ลำดับ", sortable: true },
        //     { key: "created_at", field: "created_at", label: "วันที่ออกใบแจ้งหนี้", sortable: true },
        //     { key: "invoice_no",field: "invoice_no", label: "เลขที่ใบแจ้งหนี้", sortable: true },
        //     { key: "total", field: "total", label: "ยอดเงิน (บาท)", sortable: true , 
        //         dataFormat: value => {
        //             return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
        //         }
        //     },
        //     { key: "manage", label: "จัดการใบแจ้งหนี้", sortable: true },
        // ]
    ],
    "INVOICE_SELF": [
        { key: "index", label: "ลำดับ", sortable: true },
        { key: "created_at", label: "วันที่ออกใบแจ้งหนี้", sortable: true },
        { key: "paid_at", field: "paid_at", label: "วันที่ออกใบเสร็จ", sortable: true },
        { key: "invoice_no", label: "เลขที่ใบแจ้งหนี้", sortable: true },
        { key: "receipt_no", label: "เลขที่ใบเสร็จ", sortable: true },
        { key: "total", field: "total", label: "ยอดเงิน (บาท)", sortable: true , 
            dataFormat: value => {
                return `${vm.$options.filters.numFormat(value,'0,0.00')}`;
            }
        },
        { key: "status", field: "status", label: "สถานะ", sortable: true },
        { key: "manage", label: "จัดการใบแจ้งหนี้", sortable: true }
    ],
    // "RECEIPT": [
    //     ...( ['shippop','superadmin'].includes(vm.$USER_LOGIN.get().details.role) ) 
    //     ? [
    //         { key: "index", label: "ลำดับ", sortable: true },
    //         { key: "shop_code", label: "รหัสลูกค้า", sortable: true },
    //         { key: "created_at", label: "วันที่ออกใบแจ้งหนี้", sortable: true },
    //         { key: "invoice_no", label: "เลขที่ใบแจ้งหนี้", sortable: true },
    //         { key: "receipt_no", label: "เลขที่ใบเสร็จ", sortable: true },
    //         { key: "shop_name", label: "ชื่อ", sortable: true },
    //         { key: "order_total", label: "จำนวน", sortable: true },
    //         { key: "total_courier_cost", label: "ค่าขนส่ง", sortable: true },
    //         { key: "total_service", label: "ค่าบริการ", sortable: true },
    //         { key: "vat_price", label: "Vat", sortable: true },
    //         { key: "total", label: "ยอดรวม (ราคา)", sortable: true },
    //         { key: "total_courier_cost_wht", label: "ค่าขนส่ง (หัก 1%)", sortable: true },
    //         { key: "total_service_exclude_vat_wht", label: "ค่าบริการ (หัก 3%)", sortable: true },
    //         { key: "total_net_price", label: "เงินที่จะได้รับ (หัก 1%, หัก 3%)", sortable: true },
    //         { key: "status", label: "สถานะ", sortable: true },
    //     ]
    //     : [
    //         { key: "index", label: "ลำดับ", sortable: true },
    //         { key: "updated_at", label: "วันที่ออกใบเสร็จ", sortable: true },
    //         { key: "receipt_no", label: "เลขที่ใบเสร็จรับเงิน", sortable: true },
    //         { key: "invoice_no", label: "เลขที่ใบแจ้งหนี้", sortable: true },
    //         { key: "total", label: "ยอดเงิน (บาท)", sortable: true },
    //     ]
    // ]
}
